import isEqual from 'lodash/isEqual';
import { useRef } from 'react';

export const usePreviousObjectValue = <T>(value: T) => {
  const ref = useRef<{
    value: T;
    prev: T | null;
  }>({
    value: value,
    prev: null,
  });

  const current = ref.current.value;

  if (!isEqual(value, current)) {
    ref.current = {
      value,
      prev: current,
    };
  }

  return ref.current.prev as T | null;
};
